export const createFlowEditorContext = (accountId, workflowId) => {
  let generation = 0;
  let active = true;

  const snapshot = () => ({
    accountId: accountId.value,
    workflowId: workflowId.value,
    generation,
  });

  const isCurrent = context =>
    active &&
    context.accountId === accountId.value &&
    String(context.workflowId) === String(workflowId.value) &&
    context.generation === generation;

  return {
    snapshot,
    isCurrent,
    invalidate() {
      generation += 1;
    },
    suspend() {
      active = false;
      generation += 1;
    },
    resume() {
      active = true;
      generation += 1;
    },
    dispose() {
      active = false;
      generation += 1;
    },
  };
};
